module.exports = __webpack_public_path__ + "static/media/buy_request_details_help_1.b0cd4540.png";